import {Injectable} from '@angular/core'
import {BehaviorSubject} from 'rxjs'
import {filter} from 'rxjs/operators'

@Injectable()
export class ResetFilterService {
  private filterSubject = new BehaviorSubject<boolean>(false)

  constructor() {}

  // Trigger action
  removeFilters() {
    this.filterSubject.next(true)
    // Reset back to false after emitting true
    this.filterSubject.next(false)
  }

  // Listen to action
  getFilterObservable() {
    return this.filterSubject.asObservable().pipe(
      filter((triggered) => triggered === true), // Only emit when triggered is true
    )
  }
}
